/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
import {TwitterThreadLayout} from "../../layouts/TwitterThreadLayout";
import {TwitterThreadBlock, TwitterThreadAuthor, TwitterThreadOriginalUrl, TwitterThreadBlockFirst} from "../../components/TwitterThread";
export const meta = {
  url: "https://devsforgood.com/thread/lambda-functions-in-python-with-code-snippets",
  title: "Lambda functions in Python (with code snippets)",
  description: `Lambda Functions in Python (with code snippets)`,
  image: "/covers/threads/lambda-functions-in-python-with-code-snippets.png",
  author: "Shreya Shivratriwar"
};
const MDXLayout = ({children}) => _jsx(TwitterThreadLayout, {
  meta: meta,
  children: children
});
function _createMdxContent(props) {
  const _components = Object.assign({
    p: "p",
    ul: "ul",
    li: "li",
    ol: "ol"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(TwitterThreadAuthor, {
      name: "Shreya Shivratriwar",
      username: "shreyasico",
      avatarUrl: "/avatars/shreyasico.png"
    }), "\n", _jsx(TwitterThreadOriginalUrl, {
      url: "https://twitter.com/shreyasico/status/1594584670179536896"
    }), "\n", _jsxs(TwitterThreadBlockFirst, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "Lambda Functions in Python (with code snippets)"
      }), _jsx(_components.p, {
        children: "Thread 🧵👇"
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `undefined`,
      children: _jsx(_components.p, {
        children: "Python Lambda Functions are anonymous function means that the function is without a name."
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `undefined`,
      children: _jsx(_components.p, {
        children: "As we already know that the def keyword is used to define a normal function in Python. Similarly, the lambda keyword defines an anonymous function in Python."
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/lambda-functions-in-python-with-code-snippets-3.png`,
      children: _jsx(_components.p, {
        children: "Syntax of Lambda Functions in Python"
      })
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `undefined`,
      children: _jsxs(_components.ul, {
        children: ["\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Lambda functions can have any number of arguments but only one expression."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "The expression is evaluated and returned."
          }), "\n"]
        }), "\n", _jsxs(_components.li, {
          children: ["\n", _jsx(_components.p, {
            children: "Lambda functions can be used wherever function objects are required."
          }), "\n"]
        }), "\n"]
      })
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `/images/lambda-functions-in-python-with-code-snippets-5.png`,
      children: [_jsx(_components.p, {
        children: "Example of a lambda function in Python"
      }), _jsx(_components.p, {
        children: "This lambda function converts the string into uppercase and reverses it."
      })]
    }), "\n", _jsx(TwitterThreadBlock, {
      image: `/images/lambda-functions-in-python-with-code-snippets-6.png`,
      children: _jsx(_components.p, {
        children: "Condition Checking Using Python lambda function"
      })
    }), "\n", _jsxs(TwitterThreadBlock, {
      image: `undefined`,
      children: [_jsx(_components.p, {
        children: "That's a wrap!"
      }), _jsx(_components.p, {
        children: "If you enjoyed this thread:"
      }), _jsxs(_components.ol, {
        children: ["\n", _jsx(_components.li, {
          children: "Follow me @shreyasico for more of these"
        }), "\n", _jsx(_components.li, {
          children: "RT the tweet below to share this thread with your audience https://twitter.com/1383037577779761157/status/1594584670179536896"
        }), "\n"]
      })]
    })]
  });
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
